import { render } from "./home.vue?vue&type=template&id=b2f109ce"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
script.render = render

export default script